/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Box, Button, MenuItem, TextField } from "@mui/material";
import { getAllWorkerIdentificationTypes, searchWorkers } from "../../../api/apiCall";
import { useAuth } from "../../../auth/auth";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faX } from "@fortawesome/free-solid-svg-icons";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

const StaffDetails = () => {
  const { state } = useAuth();
  const navigate = useNavigate();
  const [workers, setWorkers] = useState<any>([]);
  const [identifications, setIdentifications] = useState<any>([]);

  const {register, handleSubmit, watch} = useForm<any>({
    defaultValues: {
      name: "",
      pts: "",
      phoneNumber: "",
      notes: "",
      pageNumber: 0,
      identificationTypeId: null,
    }
  })

  const watchFields = watch();

  const getWorkers = async (data: any) => {
    const response: any = await searchWorkers(state.user?.token, data);
    setWorkers(response)
  }

  const getAllIdentifications = async () => {
       const response = await getAllWorkerIdentificationTypes(state.user?.token);
       setIdentifications(response.data);
   }

  const handleClick = (userId: any) => {
    const url = `/pace-team/resourcing/profile?workerId=${userId}`;
    window.open(url, '_blank');
  };

  const handleCreateWorker = () => {
    navigate('/pace-team/resourcing/create-worker');
  };

  const columns: any = [
    {
      field: "name",
      headerName: "Full Name",
      flex: 1.3,
      renderCell: (params: any) => (
        <div
          onClick={() => handleClick(params.row.id)}
          style={{cursor: "pointer"}}
        >
          {params.row.name} {params.row.surname}
        </div>
      ),
    },
    {
      field: "username",
      headerName: "Username",
      flex: 1,
      headerAlign: 'center',
      align: 'center'
    },
    {
      field: "pts",
      headerName: "PTS/CSCS/CPCS",
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      renderCell: (params: any) => {
        const pts = params.row?.pts;
        const ids = params.row?.identifications || [];

        return (
          <div style={{ display: "flex", flexDirection: "column", textAlign: 'start', lineHeight: ids.length >= 1 ? 1.2 : 'revert-layer' }}>
            {pts && <span>PTS: {pts}</span>}
            {ids.map((i: any) => (
              <span key={i.id}>
                {i.identificationType?.name}: {i.number}
              </span>
            ))}
          </div>
        );
      }
    },
    {
      field: "phoneNumber",
      headerName: "Phone Number",
      flex: 1,
      headerAlign: 'center',
      align: 'center'
    },
    {
      field: "email",
      headerName: "Email",
      flex: 1.3,
    },
    {
      field: "verified",
      headerName: "Verified",
      flex: 1,
      headerAlign: "center",
      align: 'center',
      renderCell: (params: any) => (
        <div>
          {params.row.verified?
            (<FontAwesomeIcon icon={faCheck} size={'lg'} color={'green'} />)
            : (<FontAwesomeIcon icon={faX} size={'lg'} color={'red'} />)}
        </div>
      ),
    },
    {
      field: "postCode",
      headerName: "Post Code",
      flex: 1,
      align: 'center',
      headerAlign: 'center'
    },
    {
      field: "details",
      headerName: "Details",
      flex: 1,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params: any) => (
        <Button
          variant="contained"
          onClick={() => handleClick(params.row.id)}
          style={{
            boxShadow: 'none',
            backgroundColor: '#6c757d'
          }}
        >
          Details
        </Button>
      )
    }
  ];

  useEffect(() => {
    setTimeout(() => {
      getWorkers(watchFields)
    }, 500)

    getAllIdentifications()
  }, [watchFields.name, watchFields.pts, watchFields.phoneNumber, watchFields.identificationTypeId])

  useEffect(() => {
    getWorkers({});
  }, []);

  return (
    <>
      <div className="form-content">
        <TextField
          label="Full Name"
          type="text"
          size="small"
          {...register("name")}
          style={{width: "15%", margin: 10}} />
        <TextField
          label="PTS"
          type="text"
          size="small"
          {...register("pts")}
          style={{width: "15%", margin: 10}} />
        <TextField
          label="Phone Number"
          id="outlined-basic"
          variant="outlined"
          type="text"
          {...register("phoneNumber")}
          size="small"
          style={{margin: 10, width: "15%"}} />
          <TextField
            select
            label="Type"
            fullWidth
            size="small"
            defaultValue={null}
            style={{margin: 10, width: "13%"}}
            {...register(`identificationTypeId`)}
          >
            {identifications.map((item: any) => (
              <MenuItem key={item.id} value={item.id}>
                {item.name}
              </MenuItem>
            ))}
          </TextField>
        {/* <TextField
          label="Notes"
          id="outlined-basic"
          variant="outlined"
          type="text"
          {...register("notes")}
          size="small"
          style={{margin: 10, width: "15%"}} /> */}
        <Button
          variant="contained"
          onClick={handleSubmit(getWorkers)}
          style={{height: 40, margin: 10, boxShadow: 'none', width: "10%"}}>
          Filter
        </Button>
        <Button
          variant="contained"
          onClick={handleCreateWorker}
          style={{height: 40, margin:10, boxShadow: 'none', width: "14.6%"}}>
          Create New Worker
        </Button>
      </div>
      <Box sx={{height: "800px", width: "90%", margin: '0 auto'}} mt={3}>
        <DataGrid
          rows={workers || []}
          columns={columns}
          disableRowSelectionOnClick
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 100,
              },
            },
          }}
          pageSizeOptions={[100]}
          sx={{
            "& .MuiDataGrid-columnHeaderTitle": {
              fontWeight: "bold",
              fontSize: 15
            },
            "& .MuiDataGrid-columnHeader": {
              backgroundColor: '#f0f0f0',
              color: "#000",
              fontWeight: "bold",
            },
            '& .disable-columns': {
              borderRight: '1px solid #bfbfbf'
            },
            '& .border-left': {
              borderLeft: '1px solid #bfbfbf',
            },
          }}
        />
      </Box>
    </>
  );
};

export default StaffDetails;
